// extracted by mini-css-extract-plugin
module.exports = {"topicNameContainer":"TopicListContainer_topicNameContainer__2mVhO","topicDescriptionContainer":"TopicListContainer_topicDescriptionContainer__3cyKi"};